export const environment = {
  production: false,
  apiConfigFile: './assets/api-staging-config.json'
};